/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
var I,L;!function(I){I[I.VISIBLE_ONLY=0]="VISIBLE_ONLY",I[I.ALL=1]="ALL",I[I.ALL_IN_CLIPPING_AREA=2]="ALL_IN_CLIPPING_AREA"}(I||(I={})),function(I){I[I.EXIT=0]="EXIT",I[I.CONTINUE=1]="CONTINUE",I[I.SKIP=2]="SKIP"}(L||(L={}));export{L as ForAllFeaturesReturnType,I as ForAllFeaturesVisibilityMode};
